import { useLocation } from 'react-router-dom';

import { getMobileRouteHeader } from '../../utils/mobileRouteHeader';
import { useMobilePageHeaderOverride } from '../../store/MobilePageHeaderContext';
import { TopBar } from './TopBar';
import { MobileRouteHeader } from './MobileRouteHeader';
import { MobileTabHeader } from './MobileTabHeader';

/**
 * Top bar mobile: logo no dashboard; voltar + título nas restantes rotas.
 */
export function MobileTopBar() {
  const { pathname } = useLocation();
  const overrideTitle = useMobilePageHeaderOverride();
  const config = getMobileRouteHeader(pathname);

  if (config.mode === 'logo') {
    return <TopBar />;
  }

  if (config.mode === 'tab') {
    return (
      <MobileTabHeader
        title={overrideTitle ?? config.title}
        actionTo={config.actionTo}
        actionLabel={config.actionLabel}
        actionIcon={config.actionIcon}
      />
    );
  }

  return (
    <MobileRouteHeader
      title={overrideTitle ?? config.title}
      backTo={config.backTo}
    />
  );
}
